import { __assign, __read, __rest } from "tslib";
import React, { useState } from 'react';
import { HeatmapChart, ResponsiveWrapper, LegendBase, theme as defaultTheme, } from '@keen.io/charts';
import { RangeSlider } from '@keen.io/ui-core';
import { useSlider } from '@keen.io/react-hooks';
import { colors } from '@keen.io/colors';
import ChartWidget from '../chart-widget';
import WidgetHeading from '../widget-heading.component';
import { legendSettings } from '../../widget-settings';
import TooManyGroupsError from './components/too-many-groups-error';
import { HeatmapWrapper } from './heatmap-chart.styles';
export var HeatmapChartWidget = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, _b = _a.legend, legend = _b === void 0 ? legendSettings : _b, _c = _a.theme, theme = _c === void 0 ? defaultTheme : _c, card = _a.card, tags = _a.tags, steps = _a.steps, props = __rest(_a, ["title", "subtitle", "legend", "theme", "card", "tags", "steps"]);
    var _d = useSlider(props.data, props.keys), min = _d.min, max = _d.max;
    var _e = __read(useState({ min: min, max: max }), 2), range = _e[0], setRange = _e[1];
    var _f = __read(useState(false), 2), tooManyGroupsError = _f[0], setTooManyGroupsError = _f[1];
    return (React.createElement(ChartWidget, { cardSettings: card, legendSettings: {
            position: legend.position,
            alignment: legend.alignment,
            layout: legend.layout,
        }, title: function () { return (React.createElement(WidgetHeading, { title: title, subtitle: subtitle, tags: tags })); }, legend: function () {
            var _a;
            return legend.enabled &&
                !tooManyGroupsError && (React.createElement(LegendBase, __assign({ fullDimension: true, spacing: "thin" }, legend),
                React.createElement(RangeSlider, { key: "range-slider-" + legend.position, minimum: min, maximum: max, layout: legend.layout, colors: theme.colors, onChange: function (min, max) {
                        setRange({ min: min, max: max });
                    }, colorSteps: steps, tooltipSettings: {
                        enabled: true,
                        position: 'bottom',
                        theme: 'light',
                        typography: {
                            fontSize: 11,
                            fontStyle: 'normal',
                            fontWeight: 'normal',
                            fontColor: colors.black['500'],
                        },
                        formatValue: (_a = props === null || props === void 0 ? void 0 : props.tooltipSettings) === null || _a === void 0 ? void 0 : _a.formatValue,
                    } })));
        }, content: function () { return (React.createElement(ResponsiveWrapper, null, function (width, height) { return (React.createElement(React.Fragment, null,
            tooManyGroupsError && React.createElement(TooManyGroupsError, null),
            React.createElement(HeatmapWrapper, { isHidden: tooManyGroupsError },
                React.createElement(HeatmapChart, __assign({}, props, { theme: theme, range: range, steps: steps, svgDimensions: { width: width, height: height }, onBlockSizeChange: function (tileSizeTooSmall) {
                        return setTooManyGroupsError(tileSizeTooSmall);
                    } }))))); })); } }));
};
export default HeatmapChartWidget;
